import { useHistory } from 'react-router-dom';

import { cn } from '@cobliteam/ui/utils';

import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';

import { LogoReducedIcon } from '@cobliteam/base-components/src/icons';

import GlobalSearch from '@cobliteam/global-search';
import InsightsButton from '@cobliteam/insights/';
import ClientAreaButton from './components/ClientAreaButton';
import FeedbackButton from './components/FeedbackButton';
import HowToUseButton from './components/HowToUseButton';
import NotificationsButton from './components/NotificationsButton';
import TrainingVideosButton from './components/TrainingVideosButton';

const NavbarDashboard = () => {
  const { coblinator } = useFeatureFlags();
  const history = useHistory();

  const onClickLogo = () => history.push('/');

  return (
    <header className={cn('z-50 w-full')}>
      <div className='flex h-14 w-full items-center justify-between border-b border-b-gray-6 bg-white px-4 shadow-sm'>
        <div className='w-32'>
          <LogoReducedIcon onClick={onClickLogo} />
        </div>
        <div className='flex gap-2.5'>
          <GlobalSearch />
          {coblinator ? <InsightsButton /> : null}
          <NotificationsButton />
          <FeedbackButton />
          <ClientAreaButton />
          <TrainingVideosButton />
          <HowToUseButton />
        </div>
      </div>
    </header>
  );
};

export default NavbarDashboard;
